import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { environment } from '../../../environments/environment';
import { IPreRegister, IRegister } from '../models/register.model';
import { IUserDetails } from 'src/app/admin/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }

        public registerProfile(value: IRegister): Observable<any> {
          return this.apiService.post(`Register/PostRegister`, value);
         }
         
         public updateCompanyForAdmin(value: IUserDetails): Observable<any> {
          return this.apiService.post(`Register/UpdateCompanyForAdmin`, value);
         }

         public GetRegisteredProfile(UserName:string): Observable<any> {
           return this.apiService.get(`UserProfiles/GetRegisteredProfile/${UserName}`);
          }
          public GetSelectedBusinessCertifications(businessCertificationIds:string): Observable<any> {
           return this.apiService.get(`Register/GetSelectedBusinessCertifications?businessCertificationIds=${businessCertificationIds}`);
          }
          public GetSelectedCountryVisa(tnVisaCountries:string): Observable<any> {
            return this.apiService.get(`Register/GetSelectedCountryIdsTNVisa?tnVisaCountries=${tnVisaCountries}`);
           }
          public onVendorAvailabilityCheck(vendorName: string,taxIdNumber:string,state:number): Observable<any> {
            return this.apiService.get(`Register/VendorAvailability?vendorName=${vendorName}&taxIdNumber=${taxIdNumber}&state=${state}`);
          }
          public onVendorNameCheck(vendorName: string): Observable<any> {
            return this.apiService.get(`Register/VendorNameDuplicateCheck?vendorName=${vendorName}`);
          }
          public onTaxIdNumberCheck(taxIdNumber: string): Observable<any> {
            return this.apiService.get(`Register/TaxIdDuplicateCheck?taxIdNumber=${taxIdNumber}`);
          }
          public onVendorEmailCheck(vendorEmail: string): Observable<any> {
            return this.apiService.get(`Register/VendorEmailDuplicateCheck?vendorEmail=${vendorEmail}`);
          }
          public onAdminEmailCheck(companyId:number,adminEmail: string): Observable<any> {
            return this.apiService.get(`Register/AdminEmailDuplicateCheck?companyId=${companyId}&adminEmail=${adminEmail}`);
          }
          public deleteOnShoreDetails(onShoreId:number): Observable<any> {
            return this.apiService.get(`CompanyProfile/DeleteOnShoreDetails?onShoreId=${onShoreId}`);
           }
           public deleteOffShoreDetails(offShoreId:number): Observable<any> {
            return this.apiService.get(`CompanyProfile/DeleteOffShoreDetails?offShoreId=${offShoreId}`);
           }
           public deleteOnReferenceDetails(onReferenceId:number): Observable<any> {
            return this.apiService.get(`CompanyProfile/DeleteOnReferenceDetails?onReferenceId=${onReferenceId}`);
           }

           public getClientNames(): Observable<any> {
            return this.apiService.get(`CompanyProfile/ClientCompanyList`);
           }

           public GetSelectedClientIds(clientIds:string): Observable<any> {
            return this.apiService.get(`Register/GetSelectedClientIds?clientIds=${clientIds}`);
           }

           public getEntityType(entityTypeId:number):Observable<any>{
            return this.apiService.get(`Register/GetEntityType?entityTypeId=${entityTypeId}`)
          }

          public getClientListForRegistration(clientIdOnRegistration:number):Observable<any>{
            return this.apiService.get(`Register/GetClientListForRegistration?clientIdOnRegistration=${clientIdOnRegistration}`)
          }
           public uploadW9Form(W9formToUpload: File):Observable<any>{
            const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
            const input : FormData =new FormData();
            input.append("file", W9formToUpload);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadW9formToTemp`, input,{responseType:'json'});
          }

          public saveW9formUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
            return this.apiService.get(`CompanyProfile/UploadW9formUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
          }

          public saveCompanyW9formUrl(companyId:number,W9form: File):Observable<any>{
            const input : FormData =new FormData();
            input.append("file", W9form);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadCompanyW9form?companyId=${companyId}`, input,{responseType:'json'});
          }

          public uploadDDForm(DDfileToUpload: File):Observable<any>{
            const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
            const input : FormData =new FormData();
            input.append("file", DDfileToUpload);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadDDFiletoTemp`, input,{responseType:'json'});
          }

          public saveDDformUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
            return this.apiService.get(`CompanyProfile/UploadDDAuthorizationFileUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
          }

          public saveCompanyDDUrl(companyId:number,W9form: File):Observable<any>{
            const input : FormData =new FormData();
            input.append("file", W9form);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadDDAuthorizationFile?companyId=${companyId}`, input,{responseType:'json'});
          }

          public uploadMSAFile(MSAfileToUpload: File):Observable<any>{
            const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
            const input : FormData =new FormData();
            input.append("file", MSAfileToUpload);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadMSAFiletoTemp`, input,{responseType:'json'});
          }

          public saveMSAFileUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
            return this.apiService.get(`CompanyProfile/UploadMSAFileUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
          }

          public saveCompanyMSAUrl(companyId:number,MsaFile: File):Observable<any>{
            const input : FormData =new FormData();
            input.append("file", MsaFile);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadMSAFile?companyId=${companyId}`, input,{responseType:'json'});
          }

          public GetW9FormUrl(w9FormFileName:string):Observable<any>{
            return this.http.get(`${environment.apiRoot}CompanyProfile/GetW9FormUrl?w9FormFileName=${w9FormFileName}`,
              {  
                  responseType: 'blob',
                  observe: 'response'
               });
          }

          public GetDDAuthorizationFileUrl(ddFileName:string):Observable<any>{
            return this.http.get(`${environment.apiRoot}CompanyProfile/GetDDAuthorizationFileUrl?ddFileName=${ddFileName}`,
              {  
                  responseType: 'blob',
                  observe: 'response'
               });
          }

          public GetMSAFileUrl(msaFileName:string):Observable<any>{
            return this.http.get(`${environment.apiRoot}CompanyProfile/GetMSAFileUrl?msaFileName=${msaFileName}`,
              {  
                  responseType: 'blob',
                  observe: 'response'
               });
          }

          public uploadInsuranceFile(InsurancefileToUpload: File):Observable<any>{
            const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
            const input : FormData =new FormData();
            input.append("file", InsurancefileToUpload);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadInsuranceFiletoTemp`, input,{responseType:'json'});
          }

          public saveInsuranceFileUrl(filePath:string,folderName:string,companyId:number):Observable<any>{
            return this.apiService.get(`CompanyProfile/UploadInsuranceFileUrl?filePath=${filePath}&folderName=${folderName}&companyId=${companyId}`);
          }

          public saveCompanyInsuranceUrl(companyId:number,InsuranceFile: File):Observable<any>{
            const input : FormData =new FormData();
            input.append("file", InsuranceFile);
            return this.http.post<any>(`${environment.apiRoot}CompanyProfile/UploadInsuranceFile?companyId=${companyId}`, input,{responseType:'json'});
          }

          public GetInsuranceFileUrl(insuranceFileName:string):Observable<any>{
            return this.http.get(`${environment.apiRoot}CompanyProfile/GetInsuranceFileUrl?insuranceFileName=${insuranceFileName}`,
              {  
                  responseType: 'blob',
                  observe: 'response'
               });
          }
          public GetRegistrationTemplate(templateName:string): Observable<any> {
            return this.apiService.get(`Register/GetRegistrationTemplate?templateName=${templateName}`);
           }
    
}